import { Box, Grid, Skeleton, Stack, useMediaQuery, useTheme } from '@mui/material';

export const CardSkeleton = () => {
  const { breakpoints } = useTheme();
  const isExtraDesktop = useMediaQuery(breakpoints.up('xl'));
  const isTablet = useMediaQuery(breakpoints.down('md'));
  const isMobile = useMediaQuery(breakpoints.down('sm'));

  const getLength = () => (isMobile ? 2 : isTablet ? 4 : isExtraDesktop ? 8 : 6);

  return (
    <Box>
      <Grid container spacing={3}>
        {Array.from({ length: getLength() }).map((_, index) => (
          <Grid key={index} item xs={12} sm={6} md={4} xl={3}>
            <Box
              sx={{
                border: '1px solid #E0E0E0',
                borderRadius: '16px',
                overflow: 'hidden',
              }}
            >
              <Skeleton variant='rectangular' width='100%' height={180} />
              <Stack direction='column' gap={1} p={2}>
                <Skeleton variant='text' width='80%' height={24} />
                <Skeleton variant='text' width='60%' height={20} />
              </Stack>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
